/* eslint-disable import/prefer-default-export */
import sortBy from '../../../common/utils/sortBy';

type ReviewLike = { rating: number; public_review?: string };

const hasReview = <T extends ReviewLike>(a: T, b: T) => {
  if (a.public_review && !b.public_review) {
    return -1;
  }
  if (!a.public_review && b.public_review) {
    return 1;
  }
  return 0;
};

const ratingDescending = <T extends ReviewLike>(a: T, b: T) => b.rating - a.rating;

export const sortReviews = <T extends ReviewLike>(reviews: T[]): T[] => (
  reviews.sort(sortBy(hasReview, ratingDescending))
);
